var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNiger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58763 9.04439C0.5705 11.1479 0 13.5077 0 16.0009C0 18.4941 0.5705 20.8539 1.58763 22.9574L16 24.3487L30.4124 22.9574C31.4295 20.8539 32 18.4941 32 16.0009C32 13.5077 31.4295 11.1479 30.4124 9.04439L16 7.65308L1.58763 9.04439Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58813 22.9575C4.17601 28.3095 9.65657 32.001 15.9999 32.001C22.3433 32.001 27.8239 28.3095 30.4118 22.9575H1.58813Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58813 9.04448H30.4118C27.8239 3.69254 22.3433 0.000976562 15.9999 0.000976562C9.65664 0.000976562 4.17601 3.69254 1.58813 9.04448Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5662C19.0736 21.5662 21.5652 19.0745 21.5652 16.001C21.5652 12.9274 19.0736 10.4358 16 10.4358C12.9264 10.4358 10.4348 12.9274 10.4348 16.001C10.4348 19.0745 12.9264 21.5662 16 21.5662Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiger);
export default __webpack_public_path__ + "static/media/niger.fe39aee2.svg";
export { ForwardRef as ReactComponent };